<table style="width:100%"
       class="table table-hover margin-bottom-0"
       datatable
       [dtOptions]="dtOptions"></table>